import Vue from 'vue';
import axios from 'axios';
import lazyLoadGrid from './components/lazy-load-grid';
import vCard from './components/v-card';

export default (() => {
    if (document.querySelector('#news-grid')) {
        new Vue({
            el: '#news-grid',
            delimiters: ['${', '}'],
            components: {
                lazyLoadGrid,
                vCard,
            },
            data: {
                articles: [],
                featuredArticlesIds: [],
                isSearching: true,
                urlQuery: (new URLSearchParams(window.location.search)).toString().replace(/All/g, ''),
            },
            computed: {
                offset() {
                    return this.articles.length;
                },
            },
            beforeMount() {
                axios.all([axios.get(`/api/news.json?${this.urlQuery}`), axios.get('/api/featurednews.json')])
                    .then(axios.spread((articles, featuredIds) => {
                        this.articles = articles.data.data;
                        this.featuredArticlesIds = featuredIds.data.data[0].ids;
                        this.isSearching = false;
                    }));
            },
            methods: {
                loadMore() {
                    this.isSearching = true;
                    axios.get(`/api/news.json?offset=${this.offset}&${this.urlQuery}`)
                        .then((response) => {
                            const data = response.data.data;
                            this.articles = this.articles.concat([...data]);
                            this.isSearching = false;
                        });
                },
            },
        });
    }
})();
